// extracted by mini-css-extract-plugin
export default {"button":"CTAButton_button__E-hh+","white":"CTAButton_white__VMS12"};